import { render } from "./outboundRecord.vue?vue&type=template&id=152fc1e6&scoped=true"
import script from "./outboundRecord.vue?vue&type=script&lang=js"
export * from "./outboundRecord.vue?vue&type=script&lang=js"

import "./outboundRecord.vue?vue&type=style&index=0&id=152fc1e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-152fc1e6"

export default script